export default __webpack_public_path__ + "static/media/balloon.4c5b1e05.svg";